import { Accordion } from '../../../../../../common/SharedComponents';
import { IGuarantorSummaryTableRow } from '../common/constants/tables/interfaces/IGuarantorSummaryTableRow';
import { ILoanHistorySummaryTableRow } from '../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { BusinessInfo } from './components/BusinessInfo';
import { GuarantorInfo } from './components/GuarantorInfo';
import { GuarantorSummaryTable } from './components/GuarantorSummaryTable';

interface GuarantorSummaryProps {
    guarantor?: string;
    business?: string;
    hasMultipleBusinesses?: boolean;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
    guarantorSummaryData: IGuarantorSummaryTableRow[] | undefined;
}
export const GuarantorSummary: React.FC<GuarantorSummaryProps> = ({
    guarantor,
    business,
    hasMultipleBusinesses,
    onLoanSummaryClick,
    guarantorSummaryData,
}) => {
    return (
        <>
            <div className='lending-limits-guarantorSummaryInfo'>
                <GuarantorInfo guarantorName={guarantor} />
                <BusinessInfo
                    businessName={business}
                    hasMultipleBusinesses={hasMultipleBusinesses}
                />
            </div>
            <Accordion
                title=''
                isExpanded={true}
                id={`bll_guarantorSummary`}
                isCollapsable={false}
            >
                <div
                    className='card'
                    style={{ width: '1075px', border: '1px solid gray' }}
                >
                    <div className='card-section'>
                        <GuarantorSummaryTable
                            onLoanSummaryClick={onLoanSummaryClick}
                            guarantorSummaryData={guarantorSummaryData}
                        />
                    </div>
                </div>
            </Accordion>
        </>
    );
};
